/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestCreateAuxiliaryDataResponse } from '../../models/harvest-create-auxiliary-data-response';

export interface GetHarvestCreateAuxiliaryDataResponse$Params {
}

export function getHarvestCreateAuxiliaryDataResponse(http: HttpClient, rootUrl: string, params?: GetHarvestCreateAuxiliaryDataResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestCreateAuxiliaryDataResponse>> {
  const rb = new RequestBuilder(rootUrl, getHarvestCreateAuxiliaryDataResponse.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestCreateAuxiliaryDataResponse>;
    })
  );
}

getHarvestCreateAuxiliaryDataResponse.PATH = '/api/harvests/auxiliary-data';
